<div class="top-row">
  <div class="image-container">
    <oph-icon [name]="'color-icons/' + (task.icon || 'alarm')" [size]="34" class="task-icon"></oph-icon>
  </div>

  <ng-content></ng-content>
</div>

<h1 class="task-label">{{ name || task.label }}</h1>

@if (showProjectAndCoin) {
  <div class="info-container">
    <div class="project info-item" [style.background]="project?.color">
      <span>{{ project?.label }}</span>
    </div>
    @if (task.taskCoinValue) {
      <div class="coin-container info-item">
        <span> {{ task.taskCoinValue }}</span>
        <oph-icon [name]="'coins/' + (coinTypeName | rewardCoinIcon)" [size]="22"></oph-icon>
      </div>
    }
  </div>
}
